export default "__VITE_ASSET__CGo4F4CB__"